export function ExpiredIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33301 9.99998H8.66634V11.3333H7.33301V9.99998ZM7.33301 4.66665H8.66634V8.66665H7.33301V4.66665ZM7.99301 1.33331C4.31301 1.33331 1.33301 4.31998 1.33301 7.99998C1.33301 11.68 4.31301 14.6666 7.99301 14.6666C11.6797 14.6666 14.6663 11.68 14.6663 7.99998C14.6663 4.31998 11.6797 1.33331 7.99301 1.33331ZM7.99967 13.3333C5.05301 13.3333 2.66634 10.9466 2.66634 7.99998C2.66634 5.05331 5.05301 2.66665 7.99967 2.66665C10.9463 2.66665 13.333 5.05331 13.333 7.99998C13.333 10.9466 10.9463 13.3333 7.99967 13.3333Z"
        fill="white"
      />
    </svg>
  );
}

export function ActiveIcon() {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.21246 4.58118C9.07863 4.71501 8.94479 4.84885 8.80959 4.98405C8.48729 5.30635 8.16636 5.62728 7.84406 5.94958C7.45621 6.33743 7.06972 6.72392 6.68187 7.11177C6.34592 7.44773 6.00996 7.78368 5.67537 8.11827C5.51422 8.27942 5.3558 8.44603 5.19056 8.60309C5.18373 8.60991 5.1769 8.61538 5.17007 8.6222C5.20694 8.59352 5.24382 8.56485 5.28069 8.53617C5.26976 8.54436 5.25884 8.54982 5.24791 8.55529C5.29162 8.53753 5.33532 8.51841 5.37902 8.50066C5.36673 8.50476 5.3558 8.50885 5.34215 8.51022C5.38994 8.50339 5.43911 8.49656 5.48691 8.4911C5.47462 8.49247 5.46232 8.49247 5.45003 8.4911C5.49783 8.49793 5.547 8.50476 5.59479 8.51022C5.5825 8.50885 5.57021 8.50612 5.55792 8.50066C5.60162 8.51841 5.64533 8.53753 5.68903 8.55529C5.67674 8.54982 5.66581 8.54436 5.65625 8.53617C5.69312 8.56485 5.73 8.59352 5.76687 8.6222C5.69449 8.55938 5.62894 8.48564 5.56065 8.41872C5.4036 8.26167 5.24791 8.10598 5.09086 7.94893C4.73715 7.59522 4.38481 7.24287 4.0311 6.88916C3.94916 6.80722 3.86858 6.72665 3.78664 6.64471C3.58452 6.44259 3.21306 6.42757 3.01367 6.64471C2.81292 6.86322 2.7979 7.2019 3.01367 7.41768C3.44522 7.84923 3.87678 8.28079 4.3097 8.7137C4.51728 8.92129 4.72623 9.13023 4.93381 9.33782C4.94883 9.35284 4.96249 9.36786 4.97751 9.38152C5.25338 9.64646 5.68083 9.64646 5.95806 9.38288C5.97991 9.3624 6.00177 9.33918 6.02225 9.3187C6.4183 8.92265 6.81571 8.52524 7.21175 8.1292C7.7908 7.55015 8.36848 6.97247 8.94752 6.39343C9.28894 6.05201 9.63309 5.71469 9.97041 5.37054C9.97588 5.36507 9.98134 5.35961 9.9868 5.35415C10.1889 5.15203 10.2039 4.78056 9.9868 4.58118C9.76693 4.38042 9.42824 4.3654 9.21246 4.58118Z"
        fill="white"
      />
      <path
        d="M11.9081 7.00251C11.9081 7.26882 11.8904 7.53513 11.8549 7.80007C11.8617 7.75227 11.8685 7.7031 11.874 7.65531C11.8043 8.17426 11.6664 8.68093 11.4643 9.16301C11.482 9.11931 11.5011 9.07561 11.5189 9.03191C11.3181 9.50852 11.0559 9.95647 10.7405 10.3662C10.7691 10.3293 10.7978 10.2924 10.8265 10.2555C10.5151 10.6571 10.1546 11.0176 9.75309 11.329C9.78996 11.3003 9.82683 11.2716 9.86371 11.2429C9.454 11.5584 9.00606 11.8206 8.52944 12.0214C8.57314 12.0036 8.61685 11.9845 8.66055 11.9667C8.17847 12.1689 7.67043 12.3068 7.15284 12.3764C7.20064 12.3696 7.24981 12.3628 7.29761 12.3573C6.76909 12.427 6.23238 12.427 5.70387 12.3573C5.75166 12.3641 5.80083 12.371 5.84863 12.3764C5.32967 12.3068 4.82301 12.1689 4.34092 11.9667C4.38462 11.9845 4.42833 12.0036 4.47203 12.0214C3.99541 11.8206 3.54747 11.5584 3.13776 11.2429C3.17464 11.2716 3.21151 11.3003 3.24838 11.329C2.84688 11.0176 2.48634 10.6571 2.17496 10.2555C2.20364 10.2924 2.23232 10.3293 2.261 10.3662C1.94553 9.95647 1.68332 9.50852 1.48257 9.03191C1.50032 9.07561 1.51944 9.11931 1.53719 9.16301C1.33508 8.68093 1.19714 8.1729 1.12749 7.65531C1.13432 7.7031 1.14115 7.75227 1.14661 7.80007C1.07696 7.27155 1.07696 6.73484 1.14661 6.20633C1.13978 6.25413 1.13296 6.30329 1.12749 6.35109C1.19714 5.83213 1.33508 5.32547 1.53719 4.84339C1.51944 4.88709 1.50032 4.93079 1.48257 4.97449C1.68332 4.49787 1.94553 4.04993 2.261 3.64023C2.23232 3.6771 2.20364 3.71397 2.17496 3.75085C2.48634 3.34934 2.84688 2.9888 3.24838 2.67743C3.21151 2.70611 3.17464 2.73479 3.13776 2.76346C3.54747 2.44799 3.99541 2.18578 4.47203 1.98503C4.42833 2.00278 4.38462 2.0219 4.34092 2.03966C4.82301 1.83754 5.33104 1.6996 5.84863 1.62996C5.80083 1.63678 5.75166 1.64361 5.70387 1.64907C6.23238 1.57943 6.76909 1.57943 7.29761 1.64907C7.24981 1.64225 7.20064 1.63542 7.15284 1.62996C7.6718 1.6996 8.17847 1.83754 8.66055 2.03966C8.61685 2.0219 8.57314 2.00278 8.52944 1.98503C9.00606 2.18578 9.454 2.44799 9.86371 2.76346C9.82683 2.73479 9.78996 2.70611 9.75309 2.67743C10.1546 2.9888 10.5151 3.34934 10.8265 3.75085C10.7978 3.71397 10.7691 3.6771 10.7405 3.64023C11.0559 4.04993 11.3181 4.49787 11.5189 4.97449C11.5011 4.93079 11.482 4.88709 11.4643 4.84339C11.6664 5.32547 11.8043 5.8335 11.874 6.35109C11.8671 6.30329 11.8603 6.25413 11.8549 6.20633C11.8904 6.4699 11.9081 6.73621 11.9081 7.00251C11.9081 7.28794 12.1594 7.56244 12.4544 7.54878C12.7494 7.53513 13.0007 7.30843 13.0007 7.00251C12.9993 6.33197 12.8982 5.65186 12.6907 5.01409C12.4899 4.39681 12.2004 3.80411 11.8234 3.27423C11.6254 2.99563 11.4096 2.72796 11.172 2.48214C10.9344 2.23495 10.6736 2.01508 10.4018 1.80613C9.88556 1.41008 9.30788 1.1069 8.69742 0.882932C8.07058 0.652133 7.39867 0.530588 6.73222 0.50464C6.06167 0.478693 5.37747 0.561999 4.73151 0.743633C4.10739 0.919805 3.49967 1.19294 2.9575 1.55075C2.42079 1.90446 1.92778 2.33191 1.51944 2.82765C1.30093 3.09123 1.09881 3.36846 0.921276 3.66344C0.742373 3.96116 0.596246 4.27253 0.465141 4.5921C0.211126 5.20939 0.0704614 5.86764 0.0185658 6.53136C-0.0346955 7.20737 0.0281255 7.89703 0.187909 8.55529C0.340865 9.18759 0.597611 9.80488 0.934933 10.3607C1.26816 10.9083 1.68469 11.4164 2.16404 11.8425C2.64749 12.2713 3.18829 12.6359 3.77827 12.9022C4.09647 13.0456 4.4215 13.1713 4.75745 13.2641C5.1016 13.3597 5.45122 13.4198 5.80629 13.4608C6.48093 13.5386 7.16514 13.4977 7.83022 13.3638C8.47072 13.2341 9.0962 12.9965 9.66705 12.6796C10.227 12.3682 10.7473 11.9654 11.1911 11.501C11.635 11.0367 12.0187 10.5027 12.3055 9.92642C12.5992 9.33645 12.8136 8.70551 12.9133 8.05408C12.9665 7.70447 13.0007 7.35349 13.002 6.99978C13.002 6.71436 12.7507 6.43986 12.4558 6.45351C12.158 6.4699 11.9081 6.6966 11.9081 7.00251Z"
        fill="white"
      />
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1640_9644"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="14"
        height="14"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.83301 1.33331H14.8175V14.318H1.83301V1.33331Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1640_9644)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.32568 2.33331C5.29701 2.33331 2.83301 4.79665 2.83301 7.82531C2.83301 10.854 5.29701 13.318 8.32568 13.318C11.3537 13.318 13.8177 10.854 13.8177 7.82531C13.8177 4.79665 11.3537 2.33331 8.32568 2.33331ZM8.32568 14.318C4.74567 14.318 1.83301 11.4053 1.83301 7.82531C1.83301 4.24531 4.74567 1.33331 8.32568 1.33331C11.9057 1.33331 14.8177 4.24531 14.8177 7.82531C14.8177 11.4053 11.9057 14.318 8.32568 14.318Z"
          fill="white"
        />
      </g>
      <mask
        id="mask1_1640_9644"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="11"
        width="5"
        height="5"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.9932 11.8046H15.3425V15.1478H11.9932V11.8046Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1640_9644)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.8427 15.1478C14.7153 15.1478 14.5873 15.0991 14.4893 15.0018L12.14 12.6591C11.9447 12.4638 11.944 12.1471 12.1393 11.9518C12.334 11.7551 12.6507 11.7565 12.8467 11.9505L15.196 14.2938C15.3913 14.4891 15.392 14.8051 15.1967 15.0005C15.0993 15.0991 14.9707 15.1478 14.8427 15.1478Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export function TimeIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99301 1.33331C4.31301 1.33331 1.33301 4.31998 1.33301 7.99998C1.33301 11.68 4.31301 14.6666 7.99301 14.6666C11.6797 14.6666 14.6663 11.68 14.6663 7.99998C14.6663 4.31998 11.6797 1.33331 7.99301 1.33331ZM7.99967 13.3333C5.05301 13.3333 2.66634 10.9466 2.66634 7.99998C2.66634 5.05331 5.05301 2.66665 7.99967 2.66665C10.9463 2.66665 13.333 5.05331 13.333 7.99998C13.333 10.9466 10.9463 13.3333 7.99967 13.3333ZM8.33301 4.66665H7.33301V8.66665L10.833 10.7666L11.333 9.94665L8.33301 8.16665V4.66665Z"
        fill="white"
      />
    </svg>
  );
}

export function UserIcon() {
  return (
    <svg
      width="22"
      height="25"
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="-mt-px"
    >
      <path
        d="M10.9993 12.9491C14.2121 12.9491 16.8254 9.5392 16.8254 6.32667C16.8254 3.11413 14.2121 0.5 10.9993 0.5C7.78645 0.5 5.17285 3.11413 5.17285 6.32667C5.17338 9.53893 7.78672 12.9491 10.9993 12.9491Z"
        fill="#636568"
      />
      <path
        d="M15.3742 13.0088C14.244 13.8699 12.8342 14.3821 11.307 14.3821H10.6936C9.16616 14.3821 7.75603 13.8696 6.62616 13.0088C2.93603 13.6053 0.118164 16.8037 0.118164 20.6619C0.118164 22.7813 4.99016 24.5 11.0003 24.5C17.0102 24.5 21.8824 22.7813 21.8824 20.6619C21.8824 16.8037 19.0643 13.6053 15.3742 13.0088Z"
        fill="#636568"
      />
    </svg>
  );
}

export function ArrowRightIcon() {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.91337 9.75566C6.73563 9.59935 6.63565 9.38735 6.63565 9.16616C6.63565 8.9451 6.73563 8.73311 6.91337 8.5768L10.035 5.83166H0.947915C0.609251 5.83166 0.296295 5.67284 0.126962 5.41493C-0.0423727 5.15703 -0.0423727 4.83912 0.126962 4.5812C0.296295 4.32328 0.609247 4.16448 0.947915 4.16448H10.035L6.91337 1.41933V1.41919C6.67643 1.20832 6.58486 0.902395 6.67278 0.616147C6.7607 0.329911 7.0151 0.106211 7.34061 0.0288613C7.6661 -0.0484559 8.01396 0.0320712 8.25379 0.240435L12.9938 4.40874C13.1717 4.56505 13.2715 4.77706 13.2715 4.9981C13.2715 5.21915 13.1717 5.4313 12.9938 5.5876L8.25379 9.75591V9.75577C8.0762 9.91222 7.83496 10 7.5836 10C7.33224 10 7.09111 9.91197 6.91337 9.75566Z"
        fill="#636568"
      />
    </svg>
  );
}

export function ArrowDownIcon() {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.244338 6.25105C0.400645 6.09033 0.612652 5.99993 0.833839 5.99993C1.0549 5.99993 1.26689 6.09033 1.4232 6.25105L4.16834 9.0736L4.16834 0.857132C4.16834 0.550916 4.32716 0.267943 4.58507 0.114833C4.84297 -0.0382777 5.16088 -0.0382777 5.4188 0.114833C5.67672 0.267943 5.83552 0.550912 5.83552 0.857132L5.83552 9.0736L8.58067 6.25105L8.58081 6.25105C8.79168 6.03681 9.0976 5.95401 9.38385 6.03351C9.67009 6.113 9.89379 6.34303 9.97114 6.63735C10.0485 6.93166 9.96793 7.24619 9.75956 7.46304L5.59126 11.7489C5.43495 11.9097 5.22294 12 5.0019 12C4.78085 12 4.5687 11.9097 4.4124 11.7489L0.244089 7.46304L0.244228 7.46304C0.087782 7.30247 5.86187e-08 7.08434 6.13289e-08 6.85706C6.40392e-08 6.62978 0.0880309 6.41176 0.244338 6.25105Z"
        fill="#636568"
      />
    </svg>
  );
}
